import { create } from 'zustand';

export type Theme = 'auto' | 'light' | 'dark';

interface ThemeState {
  theme: Theme;
  resolved: 'light' | 'dark';
  setTheme: (t: Theme) => void;
  applyDocumentClass: () => void;
}

function resolve(theme: Theme): 'light' | 'dark' {
  if (theme === 'auto') {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  return theme;
}

const STORAGE_KEY = 'ks_theme';

function loadInitial(): Theme {
  if (typeof window === 'undefined') return 'auto';
  const v = window.localStorage.getItem(STORAGE_KEY);
  return v === 'light' || v === 'dark' || v === 'auto' ? v : 'auto';
}

export const useThemeStore = create<ThemeState>((set, get) => ({
  theme: loadInitial(),
  resolved: resolve(loadInitial()),
  setTheme: (t) => {
    window.localStorage.setItem(STORAGE_KEY, t);
    set({ theme: t, resolved: resolve(t) });
    get().applyDocumentClass();
  },
  applyDocumentClass: () => {
    const resolved = get().resolved;
    document.documentElement.classList.toggle('dark', resolved === 'dark');
  },
}));

// Reakce na změnu OS preference, když je theme 'auto'
if (typeof window !== 'undefined') {
  const media = window.matchMedia('(prefers-color-scheme: dark)');
  media.addEventListener('change', () => {
    const { theme, setTheme } = useThemeStore.getState();
    if (theme === 'auto') setTheme('auto'); // re-resolve
  });
}
